import {
    LOADING_MFA_SETTINGS,
    LOADED_MFA_SETTINGS,
    UPDATING_MFA_SETTINGS,
    UPDATED_MFA_SETTINGS,
    SENT_SMS_VERIFICATION,
    VALIDATED_SMS_PHONE,
    VALIDATING_SMS_PHONE,
    ERROR_MFA_SETTINGS,
    MfaActionTypes,
} from './types';

const initialState = {
    canToggleEnrollment: false,
    isEnrolled: false,
    mfaEmail: '',
    mfaPhone: '',
    availableTypes: [],
    isValidating: false,
    isLoading: false,
    isValidatingSms: false,
    smsVerificationMessage: '',
    saveValidationMessage: null,
    saveCompleted: false,
};

const reducer = (
    state = initialState,
    action: MfaActionTypes
) => {
    switch (action.type) {
        case ERROR_MFA_SETTINGS: {
            return {
                ...state,
                isValidatingSms: false,
                isValidating: false,
                isLoading: false,
                errorMessage: action.payload,
                saveCompleted: false,
            };
        }
        case VALIDATED_SMS_PHONE: {
            return {
                ...state,
                mfaPhone: action.payload.validationPassed
                    ? action.payload.phone
                    : state.mfaPhone,
                isValidatingSms: false,
                smsVerificationMessage: action.payload.errorMessage,
                errorMessage: '',
            };
        }
        case VALIDATING_SMS_PHONE: {
            return {
                ...state,
                isValidatingSms: true,
                smsVerificationMessage: '',
                errorMessage: '',
            };
        }
        case SENT_SMS_VERIFICATION: {
            return {
                ...state,
                smsVerificationSequence: action.payload.sequence,
            };
        }
        case LOADED_MFA_SETTINGS: {
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isValidated: true,
                saveCompleted: false,
            };
        }
        case LOADING_MFA_SETTINGS: {
            return {
                ...state,
                isLoading: true,
                isValidated: false,
                saveCompleted: false,
            };
        }
        case UPDATING_MFA_SETTINGS: {
            return {
                ...state,
                isValidating: true,
                saveCompleted: false,
            };
        }
        case UPDATED_MFA_SETTINGS: {
            return {
                ...state,
                isValidating: false,
                saveCompleted: true,
            };
        }
        default:
            return state;
    }
};

export default reducer;
